<template>
  <div>
    <div
      v-for="(question, questionIndex) in response.content.data"
      :key="questionIndex"
    >
      <div class="flex justify-between flex-nowrap pb-2 border-base-30 border-b p-4">
        <div>
          <div v-if="isTreatmentSlideTypePreview" class="quiz__type">
            Short Answer
          </div>
          <div v-else class="quiz__type">
            {{ $i18nPresenter.t('Type Answer') }}
          </div>
          <p class="font-bold" :class="{'text-base': isModalContent}">
            {{ question.questionTitle }}
          </p>
        </div>
        <div class="flex-shrink-0 pl-7">
          <aha-button
            @click="handleAddSlideToPresentation(response)"
            :submitting="response.isAddingSlide"
            :disabled="response.isDisabled || response.isAddingSlide"
          >
            {{ $i18nPresenter.t('Add') }}
          </aha-button>
        </div>
      </div>
      <div class="quiz-item-correct-answer">
        <p>{{ question.correctQuizTypeAnswer }}</p>
      </div>
      <ul class="quiz-item__other-answers">
        <p
          class="text-base-80 border-t border-base-30 pt-4"
          v-if="question.otherCorrectQuiz && question.otherCorrectQuiz.length"
        >
          {{ $i18nPresenter.t('Alternative answers:') }}
        </p>
        <div class="quiz-item__other-answers-list">
          <li
            v-for="otherCorrectQuiz in question.otherCorrectQuiz"
            :key="otherCorrectQuiz.index"
            class="quiz-item__other-answer"
          >
            <span class="text-base-50 pr-2">•</span>
            <span>{{ otherCorrectQuiz.title }}</span>
          </li>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    response: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
      default: null,
    },
    isModalContent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isTreatmentSlideTypePreview']),
  },
  methods: {
    handleAddSlideToPresentation(response) {
      this.$emit('handleAddSlideToPresentation', response)
    },
  },
}
</script>

<style lang="scss">
.quiz__type {
  background-color: #EFF1F7; // secondary-15
  width: max-content;
  font-size: 12px;
  border-radius: 20px;
  padding: 0 0.5rem;
  color: #3F4557; // secondary-60
  margin-bottom: 0.5rem;
}

.quiz-item__other-answers {
  display: block;
  padding: 0 1rem 1rem 1rem;
  list-style: none !important;
  .quiz-item__other-answers-list {
    display: flex;
    padding-right: 0;
    margin-right: 0;
  }
  .quiz-item__other-answer {
    display: flex;
    width: 50%;
    padding: 0 2.25rem 1rem 0;
  }
}

.quiz-item-correct-answer {
  padding: 1rem 2.25rem 1rem 1rem;
}
</style>
